export const getUserRoutes = (username: string) => {
    const handle = encodeURIComponent(username)

    return {
        audio: `/${handle}`,
        collections: `/${handle}/collections`,
        projects: `/${handle}/projects`,
        promoPages: `/${handle}/promo-pages`,
        insights: `/${handle}/insights`,
    }
}
